// extracted by mini-css-extract-plugin
module.exports = {"form":"PhoneNumberInput_form__R16C8","prefixSection":"PhoneNumberInput_prefixSection__2k3o4","numberSection":"PhoneNumberInput_numberSection__2yxim"};